/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-base-to-string
      resolve(String(fileReader.result));
    };
    fileReader.onerror = () => {
      reject(new Error(`Error reading file ${file.name}`));
    };
  });
};

export default convertToBase64;
